import React from "react";

const STATUS_CONFIG = {
  FRESH_BUY_SIGNAL:       { label: "Fresh Buy",       bg: "#16a34a", text: "#fff" },
  NEAR_BREAKOUT:          { label: "Near Breakout",    bg: "#2563eb", text: "#fff" },
  PULLBACK_BUY_ZONE:      { label: "Pullback Buy",     bg: "#0891b2", text: "#fff" },
  BUY_CANDIDATE:          { label: "Buy Candidate",    bg: "#65a30d", text: "#fff" },
  CONSOLIDATION_STAGE:    { label: "Consolidation",    bg: "#7c3aed", text: "#fff" },
  HOLD:                   { label: "Hold",             bg: "#1d4ed8", text: "#fff" },
  BOOK_PARTIAL_PROFIT:    { label: "Book Partial",     bg: "#d97706", text: "#fff" },
  T2_REACHED:             { label: "T2 Reached",       bg: "#b45309", text: "#fff" },
  WEAKENING_MOMENTUM:     { label: "Weakening",        bg: "#ea580c", text: "#fff" },
  TREND_REVERSAL_WARNING: { label: "Reversal Warning", bg: "#dc2626", text: "#fff" },
  SELL_EXIT:              { label: "Sell / Exit",      bg: "#991b1b", text: "#fff" },
  STOP_LOSS_TRIGGERED:    { label: "Stop Loss Hit",    bg: "#7f1d1d", text: "#fff" },
  RE_ENTRY_WATCH:         { label: "Re-Entry Watch",   bg: "#0369a1", text: "#fff" },
  NO_TRADE_ZONE:          { label: "No Trade",         bg: "#e5e7eb", text: "#6b7280" },
  AVOID:                  { label: "Avoid",            bg: "#f3f4f6", text: "#9ca3af" },
  ERROR:                  { label: "Error",            bg: "#fef2f2", text: "#ef4444" },
};

export default function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, bg: "#e5e7eb", text: "#374151" };
  return (
    <span style={{
      display: "inline-block",
      padding: "2px 8px",
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.02em",
      background: cfg.bg,
      color: cfg.text,
      whiteSpace: "nowrap"
    }}>
      {cfg.label}
    </span>
  );
}

export { STATUS_CONFIG };
